// Admin
export const ADMIN_HANDLE_SUPER = 'ADMIN_HANDLE_SUPER'
export const ADMIN_HANDLE_BUILDING = 'ADMIN_HANDLE_BUILDING'
export const ADMIN_HANDLE_TENANT = 'ADMIN_HANDLE_TENANT'
export const ADMIN_SET_CLIENTS = 'ADMIN_SET_CLIENTS'
export const ADMIN_SET_CLIENT_ENTRY = 'ADMIN_SET_CLIENT_ENTRY'
export const ADMIN_SET_PROPERTIES = 'ADMIN_SET_PROPERTIES'
export const ADMIN_SET_PROPERTY_ENTRY = 'ADMIN_SET_PROPERTY_ENTRY'
export const ADMIN_SET_REGIONS = 'ADMIN_SET_REGIONS'
export const ADMIN_SET_BUILDINGS = 'ADMIN_SET_BUILDINGS'
export const ADMIN_SET_BUILDING_ENTRY = 'ADMIN_SET_BUILDING_ENTRY'
export const ADMIN_UPDATE_BUILDING = 'ADMIN_UPDATE_BUILDING'

export const ADMIN_SET_TENANTS = 'ADMIN_SET_TENANTS'
export const ADMIN_SET_TENANT_ENTRY = 'ADMIN_SET_TENANT_ENTRY'
export const ADMIN_SET_TENANTS_ADD = 'ADMIN_SET_TENANTS_ADD'
export const ADMIN_REMOVE_TENANT = 'ADMIN_REMOVE_TENANT'
export const ADMIN_UPDATE_TENANT = 'ADMIN_UPDATE_TENANT'

export const ADMIN_SET_USERS = 'ADMIN_SET_USERS'
export const ADMIN_SET_REQUESTS = 'ADMIN_SET_REQUESTS'
export const ADMIN_SET_REQUEST_ENTRY = 'ADMIN_SET_REQUEST_ENTRY'
export const ADMIN_REMOVE_REQUEST_ENTRY = 'ADMIN_REMOVE_REQUEST_ENTRY'
export const ADMIN_SET_GROUPS = 'ADMIN_SET_GROUPS'
export const ADMIN_UPDATE_GROUP = 'ADMIN_UPDATE_GROUP'
export const ADMIN_SET_GROUP_ENTRY = 'ADMIN_SET_GROUP_ENTRY'

// App
export const UPDATE_USER_ROLES = 'UPDATE_USER_ROLES'
export const APP_ADD_IMG_TO_LOADER = 'APP_ADD_IMG_TO_LOADER'
export const APP_REMOVE_IMG_FROM_LOADER = 'APP_REMOVE_IMG_FROM_LOADER'
export const APP_SET_SEARCH = 'APP_SET_SEARCH'
export const APP_SHOW_PICTURE_UPLOADER = 'APP_SHOW_PICTURE_UPLOADER'
export const APP_TOGGLE_ADMIN_MODE = 'APP_TOGGLE_ADMIN_MODE'
export const APP_UPDATE_ATTRIBUTE = 'APP_UPDATE_ATTRIBUTE'
export const HANDLE_CHANGE = 'HANDLE_CHANGE'
export const SET_TRAINING_RESULTS = 'SET_TRAINING_RESULTS'
export const SET_USER_ATTRIBUTES = 'SET_USER_ATTRIBUTES'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_USER_OCCUPANCIES = 'SET_USER_OCCUPANCIES'
export const SET_ADMIN_STATUS = 'SET_ADMIN_STATUS'
export const SHOW_UPDATE_ATTRIBUTES = 'SHOW_UPDATE_ATTRIBUTES'
export const SHOW_BUILDING_PICKER = 'SHOW_BUILDING_PICKER'
export const UPDATE_BUILDING_DATA = 'UPDATE_BUILDING_DATA'
export const UPDATE_TENANT_DATA = 'UPDATE_TENANT_DATA'
export const UPDATE_TRAINING_RESULT = 'UPDATE_TRAINING_RESULT'
export const UPDATE_WINDOW_DIMENSIONS = 'UPDATE_WINDOW_DIMENSIONS'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const APP_SHOW_ERROR_PAGE = 'APP_SHOW_ERROR_PAGE'
export const APP_SET_PLAYLISTS = 'APP_SET_PLAYLISTS'
export const APP_SET_PROPERTY_PLAYLISTS = 'APP_SET_PROPERTY_PLAYLISTS'
export const APP_SET_LOADING = 'APP_SET_LOADING'

// Auth
export const AUTH_SET_USER = 'AUTH_SET_USER'
export const AUTH_SHOW_RESET_PASSWORD = 'AUTH_SHOW_RESET_PASSWORD'
export const AUTH_SHOW_LOGIN = 'AUTH_SHOW_LOGIN'
export const LOGIN_SHOW_NEW_PASSWORD = 'LOGIN_SHOW_NEW_PASSWORD'
export const AUTH_SET_PASSWORD_RESET_TOKEN = 'AUTH_SET_PASSWORD_RESET_TOKEN'
export const REGISTRATION_SET_TOKEN = 'REGISTRATION_SET_TOKEN'
export const REGISTRATION_SET_DATA = 'REGISTRATION_SET_DATA'
export const REGISTRATION_SET_LOADING = 'REGISTRATION_SET_LOADING'
export const REGISTRATION_SET_USER_ATTRIBUTES = 'REGISTRATION_SET_USER_ATTRIBUTES'
export const REGISTRATION_SET_ERROR_MESSAGE = 'REGISTRATION_SET_ERROR_MESSAGE'
export const REGISTRATION_SHOW_CONFIRMATION_FORM = 'REGISTRATION_SHOW_CONFIRMATION_FORM'
export const REGISTRATION_SET_SHOW_POP_UP = 'REGISTRATION_SET_SHOW_POP_UP'
export const REGISTRATION_SET_SHOW_HELP = 'REGISTRATION_SET_SHOW_HELP'
export const REGISTRATION_SET_CREATE_OCCUPANCY = 'REGISTRATION_SET_CREATE_OCCUPANCY'
export const REGISTRATION_SET_SHOW_NOTIFICATION = 'REGISTRATION_SET_SHOW_NOTIFICATION'

// FLOOR WARDEN
export const FW_SET_FLOOR_WARDENS = 'FW_SET_FLOOR_WARDENS'
export const FW_SET_FILTERED_FLOOR_WARDENS = 'FW_SET_FILTERED_FLOOR_WARDENS'
export const FW_SET_FLOORS = 'FW_SET_FLOORS'
export const FW_SET_IS_FLOOR_WARDEN = 'FW_SET_IS_FLOOR_WARDEN'
export const FW_SET_FLOOR_WARDEN = 'FW_SET_FLOOR_WARDEN'
export const FW_TOGGLE_REGISTRATION = 'FW_TOGGLE_REGISTRATION'
export const FW_TOGGLE_DELETE_CONFIRM = 'FW_TOGGLE_DELETE_CONFIRM'
export const FW_SET_REGISTRATION_TYPE = 'FW_SET_REGISTRATION_TYPE'
export const FW_SET_REGISTRATION_FLOOR = 'FW_SET_REGISTRATION_FLOOR'
export const FW_SET_REGISTRATION_POSITION = 'FW_SET_REGISTRATION_POSITION'
export const FW_SET_REGISTRATION_ROLE = 'FW_SET_REGISTRATION_ROLE'
export const FW_SET_REGISTRATION_CONFIRMATION = 'FW_SET_REGISTRATION_CONFIRMATION'
export const FW_SET_PENDING_REQUEST = 'FW_SET_PENDING_REQUEST'
export const FW_SET_MESSAGE = 'FW_SET_MESSAGE'
export const FW_SET_ERROR_MESSAGE = 'FW_SET_ERROR_MESSAGE'
export const FW_ADD_FLOOR_WARDEN_ENTRY = 'FW_ADD_FLOOR_WARDEN_ENTRY'
export const FW_REMOVE_FLOOR_WARDEN_ENTRY = 'FW_REMOVE_FLOOR_WARDEN_ENTRY'
export const FW_SET_ACKNOWLEDGED = 'FW_SET_ACKNOWLEDGED'
export const FW_SET_FILTERED_REQUESTS = 'FW_SET_FILTERED_REQUESTS'
export const FW_SET_SELECTED = 'FW_SET_SELECTED'
export const FW_SET_FLOOR_WARDEN_REQUESTS = 'FW_SET_FLOOR_WARDEN_REQUESTS'
export const FW_REMOVE_FLOOR_WARDEN_REQUEST = 'FW_REMOVE_FLOOR_WARDEN_REQUEST'

// Analytics
export const ANALYTICS_PAGE_VIEW = 'ANALYTICS_PAGE_VIEW'
export const ANALYTICS_USER_LOGIN = 'ANALYTICS_USER_LOGIN'

// Notifications
export const NOTIFICATIONS_SET_TEMPLATES = 'NOTIFICATIONS_SET_TEMPLATES'
export const NOTIFICATIONS_ADD_TEMPLATE = 'NOTIFICATIONS_ADD_TEMPLATE'
export const NOTIFICATIONS_UPDATE_TEMPLATE = 'NOTIFICATIONS_UPDATE_TEMPLATE'
export const NOTIFICATIONS_REMOVE_TEMPLATE = 'NOTIFICATIONS_REMOVE_TEMPLATE'
export const RESET_BADGE_COUNT = 'RESET_BADGE_COUNT'

// Reports
export const REPORTS_SET_REPORT = 'REPORT_SET_REPORT'
export const REPORTS_SET_LOADING = 'REPORTS_SET_LOADING'
export const REPORTS_SET_METRICS = 'REPORTS_SET_METRICS'
export const REPORTS_SET_SELECTED_PLAYLIST = 'REPORTS_SET_SELECTED_PLAYLIST'
export const REPORTS_SET_PLAYLISTS = 'REPORTS_SET_PLAYLISTS'
export const REPORTS_SET_TENANT = 'REPORTS_SET_TENANT'
export const REPORTS_SET_STATUS_FILTER = 'REPORTS_SET_STATUS_FILTER'
export const REPORTS_SET_TENANTS = 'REPORTS_SET_TENANTS'
export const REPORTS_SET_GRAPH_KEYS = 'REPORTS_SET_GRAPH_KEYS'
export const REPORTS_SET_SHOW_PERCENT = 'REPORTS_SET_SHOW_PERCENT'
export const REPORTS_SET_STATUS_DATA = 'REPORTS_SET_STATUS_DATA'
export const REPORTS_SET_SHOW_USER_DETAILS = 'REPORTS_SET_SHOW_USER_DETAILS'
export const REPORTS_SET_SHOW_CREATE_ADMIN = 'REPORTS_SET_SHOW_CREATE_ADMIN'
export const REPORTS_SET_SHOW_ACKNOWLEDGEMENT_DETAILS = 'REPORTS_SET_SHOW_ACKNOWLEDGEMENT_DETAILS'
export const REPORTS_SET_SHOW_FILTER_MENU = 'REPORTS_SET_SHOW_FILTER_MENU'
export const REPORTS_RESET_PROGRAM_REPORTS = 'REPORTS_RESET_PROGRAM_REPORTS'
export const REPORTS_SET_USER_STATUS = 'REPORTS_SET_USER_STATUS'

// Training Program
export const ADD_CONTENT_TO_PLAYLIST = 'ADD_CONTENT_TO_PLAYLIST'
export const ADD_TRANSLATED_PLAYLIST = 'ADD_TRANSLATED_PLAYLIST'
export const ADD_TRANSLATED_QUIZ = 'ADD_TRANSLATED_QUIZ'
export const ADD_TRANSLATED_SECTION = 'ADD_TRANSLATED_SECTION'
export const ADD_TRANSLATED_VIDEO = 'ADD_TRANSLATED_VIDEO'
export const CLEAR_HISTORY = 'CLEAR_HISTORY'
export const HANDLE_PLAYLIST = 'HANDLE_PLAYLIST'
export const NEXT_PLAYLIST_CONTENT = 'NEXT_PLAYLIST_CONTENT'
export const POP_FROM_HISTORY = 'POP_FROM_HISTORY'
export const PREVIOUS_PLAYLIST_CONTENT = 'PREVIOUS_PLAYLIST_CONTENT'
export const PUSH_TO_HISTORY = 'PUSH_TO_HISTORY'
export const RESET_TRAINING_PROGRAM = 'RESET_TRAINING_PROGRAM'
export const SET_ACTIVE_CONTENT = 'SET_ACTIVE_CONTENT'
export const SET_ACTIVE_TRANSLATION = 'SET_ACTIVE_TRANSLATION'
export const SET_IS_TRANSLATING = 'SET_IS_TRANSLATING'
export const SET_NEXT_BUTTON_DISABLED = 'SET_NEXT_BUTTON_DISABLED'
export const SET_SHOW_COMPLETION = 'SET_SHOW_COMPLETION'
export const SET_UPDATING_TRAINING_RESULT = 'SET_UPDATING_TRAINING_RESULT'
export const SET_VIDEO_AUTOPLAY = 'SET_VIDEO_AUTOPLAY'
export const SET_VIDEO_CC = 'SET_VIDEO_CC'

// Library
export const LIBRARY_SET_LOADING = 'LIBRARY_SET_LOADING'
export const LIBRARY_DESELECT = 'LIBRARY_DESELECT'
export const LIBRARY_FILTER_BUILDING = 'LIBRARY_FILTER_BUILDING'
export const LIBRARY_FILTER_CLIENT = 'LIBRARY_FILTER_CLIENT'
export const LIBRARY_FILTER_PROPERTY = 'LIBRARY_FILTER_PROPERTY'
export const LIBRARY_UPDATE_QUIZ = 'LIBRARY_UPDATE_QUIZ'
export const LIBRARY_UPDATE_VIDEO = 'LIBRARY_UPDATE_VIDEO'
export const LIBRARY_UPDATE_PLAYLIST = 'LIBRARY_UPDATE_PLAYLIST'
export const LIBRARY_REMOVE_PLAYLIST = 'LIBRARY_REMOVE_PLAYLIST'
export const LIBRARY_REMOVE_QUIZ = 'LIBRARY_REMOVE_QUIZ'
export const LIBRARY_REMOVE_VIDEO = 'LIBRARY_REMOVE_VIDEO'
export const LIBRARY_SET_DATE_FROM = 'LIBRARY_SET_DATE_FROM'
export const LIBRARY_SET_DATE_UNTIL = 'LIBRARY_SET_DATE_UNTIL'
export const LIBRARY_SET_ERRORS = 'LIBRARY_SET_ERRORS'
export const LIBRARY_SET_PLAYLISTS = 'LIBRARY_SET_PLAYLISTS'
export const LIBRARY_SET_PLAYLIST_ENTRY = 'LIBRARY_SET_PLAYLIST_ENTRY'
export const LIBRARY_SET_QUIZZES = 'LIBRARY_SET_QUIZZES'
export const LIBRARY_SET_QUIZ_ENTRY = 'LIBRARY_SET_QUIZ_ENTRY'
export const LIBRARY_SET_SEARCH_STRING = 'LIBRARY_SET_SEARCH_STRING'
export const LIBRARY_SET_SPECIFICITY = 'LIBRARY_SET_SPECIFICITY'
export const LIBRARY_SET_VIDEOS = 'LIBRARY_SET_VIDEOS'
export const LIBRARY_SET_VIDEO_ENTRY = 'LIBRARY_SET_VIDEO_ENTRY'
export const LIBRARY_TOGGLE_FILTERS = 'LIBRARY_TOGGLE_FILTERS'
export const LIBRARY_TOGGLE_PLAYLIST_MUTATOR = 'LIBRARY_TOGGLE_PLAYLIST_MUTATOR'
export const LIBRARY_TOGGLE_QUIZ_MUTATOR = 'LIBRARY_TOGGLE_QUIZ_MUTATOR'
export const LIBRARY_TOGGLE_VIDEO_MUTATOR = 'LIBRARY_TOGGLE_VIDEO_MUTATOR'
export const LIBRARY_TOGGLE_PROCEDURE_MUTATOR = 'LIBRARY_TOGGLE_PROCEDURE_MUTATOR'

// Playlist Mutator
export const PLAYLIST_MUTATOR_ADD_CONTENT = 'PLAYLIST_MUTATOR_ADD_SECTION_CONTENT'
export const PLAYLIST_MUTATOR_ADD_SECTION = 'PLAYLIST_MUTATOR_ADD_PLAYLIST_SECTION'
export const PLAYLIST_MUTATOR_CANCEL_SELECTION = 'PLAYLIST_MUTATOR_CANCEL_SELECTION'
export const PLAYLIST_MUTATOR_COPY = 'PLAYLIST_MUTATOR_COPY'
export const PLAYLIST_MUTATOR_HIDE_CONTENT = 'PLAYLIST_MUTATOR_HIDE_CONTENT'
export const PLAYLIST_MUTATOR_LOAD_SELECTED = 'PLAYLIST_MUTATOR_LOAD_SELECTED'
export const PLAYLIST_MUTATOR_MOVE_CONTENT_DOWN = 'PLAYLIST_MUTATOR_MOVE_CONTENT_DOWN'
export const PLAYLIST_MUTATOR_MOVE_CONTENT_UP = 'PLAYLIST_MUTATOR_MOVE_CONTENT_UP'
export const PLAYLIST_MUTATOR_REMOVE_CONTENT = 'PLAYLIST_MUTATOR_REMOVE_CONTENT'
export const PLAYLIST_MUTATOR_REMOVE_SECTION = 'PLAYLIST_MUTATOR_REMOVE_SECTION'
export const PLAYLIST_MUTATOR_RESET_DEFAULTS = 'PLAYLIST_MUTATOR_RESET_DEFAULTS'
export const PLAYLIST_MUTATOR_SELECT_CONTENT = 'PLAYLIST_MUTATOR_SELECT_CONTENT'
export const PLAYLIST_MUTATOR_SELECT_SECTION = 'PLAYLIST_MUTATOR_SELECT_SECTION'
export const PLAYLIST_MUTATOR_SET_BUILDING = 'PLAYLIST_MUTATOR_SET_BUILDING'
export const PLAYLIST_MUTATOR_SET_CERTIFICATE_TYPE = 'PLAYLIST_MUTATOR_SET_CERTIFICATE_TYPE'
export const PLAYLIST_MUTATOR_SET_CLIENT = 'PLAYLIST_MUTATOR_SET_CLIENT'
export const PLAYLIST_MUTATOR_SET_DESCRIPTION = 'PLAYLIST_MUTATOR_SET_DESCRIPTION'
export const PLAYLIST_MUTATOR_SET_PLAYLIST_TITLE = 'PLAYLIST_MUTATOR_SET_PLAYLIST_TITLE'
export const PLAYLIST_MUTATOR_SET_PROPERTY = 'PLAYLIST_MUTATOR_SET_PROPERTY'
export const PLAYLIST_MUTATOR_SET_SECTION_TITLE = 'PLAYLIST_MUTATOR_SET_SECTION_TITLE'
export const PLAYLIST_MUTATOR_SET_SELECTION_MODE = 'PLAYLIST_MUTATOR_SET_SELECTION_MODE'
export const PLAYLIST_MUTATOR_SET_USER_TYPE = 'PLAYLIST_MUTATOR_SET_USER_TYPE'
export const PLAYLIST_MUTATOR_SET_HLS = 'PLAYLIST_MUTATOR_SET_HLS'
export const PLAYLIST_MUTATOR_SET_CC = 'PLAYLIST_MUTATOR_SET_CC'
export const PLAYLIST_MUTATOR_SET_ORDER = 'PLAYLIST_MUTATOR_SET_ORDER'

// Quiz Mutator
export const QUIZ_MUTATOR_ADD_ANSWER = 'QUIZ_MUTATOR_ADD_ANSWER'
export const QUIZ_MUTATOR_LOAD_SELECTED = 'QUIZ_MUTATOR_LOAD_SELECTED'
export const QUIZ_MUTATOR_REMOVE_ANSWER = 'QUIZ_MUTATOR_REMOVE_ANSWER'
export const QUIZ_MUTATOR_RESET = 'QUIZ_MUTATOR_RESET'
export const QUIZ_MUTATOR_SET_ANSWER = 'QUIZ_MUTATOR_SET_ANSWER'
export const QUIZ_MUTATOR_SET_AUTO_TRANSLATIONS = 'QUIZ_MUTATOR_SET_AUTO_TRANSLATIONS'
export const QUIZ_MUTATOR_SET_CORRECT = 'QUIZ_MUTATOR_SET_CORRECT'
export const QUIZ_MUTATOR_SET_QUESTION = 'QUIZ_MUTATOR_SET_QUESTION'
export const QUIZ_MUTATOR_SET_TITLE = 'QUIZ_MUTATOR_SET_TITLE'
export const QUIZ_MUTATOR_SET_TRANSLATION = 'QUIZ_MUTATOR_SET_TRANSLATION'
export const QUIZ_MUTATOR_SET_SHOW_VALIDATION = 'QUIZ_MUTATOR_SET_SHOW_VALIDATION'
export const QUIZ_MUTATOR_TOGGLE_AUTO_TRANSLATIONS = 'QUIZ_MUTATOR_TOGGLE_AUTO_TRANSLATIONS'
export const QUIZ_MUTATOR_SET_PROPERTY = 'QUIZ_MUTATOR_SET_PROPERTY'
export const QUIZ_MUTATOR_SET_BUILDING = 'QUIZ_MUTATOR_SET_BUILDING'
export const QUIZ_MUTATOR_SET_CLIENT = 'QUIZ_MUTATOR_SET_CLIENT'

// Video Mutator
export const VIDEO_MUTATOR_LOAD_SELECTED = 'VIDEO_MUTATOR_LOAD_SELECTED'
export const VIDEO_MUTATOR_RESET = 'VIDEO_MUTATOR_RESET'
export const VIDEO_MUTATOR_SET_BUILDING_PK = 'VIDEO_MUTATOR_SET_BUILDING_PK'
export const VIDEO_MUTATOR_SET_CLIENT_PK = 'VIDEO_MUTATOR_SET_CLIENT_PK'
export const VIDEO_MUTATOR_SET_PROPERTY_PK = 'VIDEO_MUTATOR_SET_PROPERTY_PK'
export const VIDEO_MUTATOR_SET_THUMBNAIL = 'VIDEO_MUTATOR_SET_THUMBNAIL'
export const VIDEO_MUTATOR_SET_TITLE = 'VIDEO_MUTATOR_SET_TITLE'
export const VIDEO_MUTATOR_SET_TRANSLATION_REQUESTS = 'VIDEO_MUTATOR_SET_TRANSLATION_REQUESTS'
export const VIDEO_MUTATOR_SET_UPLOADING = 'VIDEO_MUTATOR_SET_UPLOADING'
export const VIDEO_MUTATOR_SET_UPLOAD_PROGRESS = 'VIDEO_MUTATOR_SET_UPLOAD_PROGRESS'
export const VIDEO_MUTATOR_SET_VIDEO = 'VIDEO_MUTATOR_SET_VIDEO'
export const VIDEO_MUTATOR_SET_VIDEO_FRAME = 'VIDEO_MUTATOR_SET_VIDEO_FRAME'
export const VIDEO_MUTATOR_SET_VIDEO_FRAME_CONTEXT = 'VIDEO_MUTATOR_SET_VIDEO_FRAME_CONTEXT'
export const VIDEO_MUTATOR_SET_VIDEO_PREVIEW = 'VIDEO_MUTATOR_SET_VIDEO_PREVIEW'

export const SET_TERMS_ACCEPTED = 'SET_TERMS_ACCEPTED';
export const SHOW_TERMS_OF_USE = 'SHOW_TERMS_OF_USE';
